import * as React from "react";
import cx from "clsx";
const TextWrapper = ({
  active,
  children
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cx("de:min-h-md", active ? "[&>p]:text-ink-dark" : "[&>p]:text-ink-light")
  }, children);
};
export default TextWrapper;